import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MainApp from './App';  // Updated to reference the new path

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MainApp />
  </React.StrictMode>,
);
